import { FC, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { useNavigate } from 'react-router';
import strings from './error.translations';
import { Button } from '../button/Button';
import { Card } from '../card/Card';
import { merge } from '../../utils/utility';

interface Props {
  error: Error;
  onClear: () => void;
  className?: string;
  goHome?: boolean;
}

export const ErrorCard: FC<Props> = ({ error, onClear, className, goHome }) => {
  const navigate = useNavigate();
  const [showDetails, setShowDetails] = useState<boolean>(false);

  const handleReset = () => {
    onClear();
    navigate('/');
  };

  return (
    <Card className={merge('flex flex-col items-center gap-5 text-primary-800', className)}>
      <FiAlertTriangle className="h-16 w-16" />
      <p className="text-xl max-w-md text-center">{strings.message}</p>
      <div className="flex gap-5">
        {goHome && <Button primary onClick={handleReset}>
          {strings.goHome}
        </Button>}
        <Button onClick={() => setShowDetails(!showDetails)}>
          {showDetails ? strings.hideDetails : strings.showDetails}
        </Button>
      </div>
      {showDetails && (
        <div className="">
          <p className="text-2xl font-bold">{error.name}</p>
          <p>{error.message}</p>
          <p>{error.stack}</p>
        </div>
      )}
    </Card>
  );
};
